<template>
  <div v-if="!loading && contract_manager && role">
    <h1 class="main-header">
      <translate translate-context="contract_managers"
                 :translate-params="{id: contract_manager.id, name: contract_manager.name, role_name: role.name}">
        Edit Role "%{role_name}" - Contract Manager #%{id} - %{name}
      </translate>
    </h1>

    <CCard>
      <CCardHeader>
        <div class="card-header-actions">
          <CButton variant="outline" color="success" @click="onReset" class="mr-2" v-translate translate-context="form">Reset</CButton>
          <CButton color="primary" @click="onClickSave" v-translate translate-context="form">Save</CButton>
        </div>
      </CCardHeader>
      <CCardBody>
        <RoleForm ref="role_form" :data="role" @save="onSave" :save_text="$pgettext('form','Save')" edit/>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {RecordNotFound, SuccessNotification} from "@/domain/core/exception/exceptions";
import RoleForm from "@/domain/contract_manager/components/RoleForm.vue";

export default {
  name: 'EditRole',
  components: {RoleForm},
  data() {
    return {
      loading: true,
    }
  },
  async mounted() {
    try {
      // fetchContractManager deve completarsi prima di fetchRole
      // perché fetchRole dipende da contract_manager.id nello store
      await this.fetchContractManager(this.$route.params.id)
      await Promise.all([
        this.fetchConfig({type: 'contract_manager_detail', id: this.$route.params.id}),
        this.fetchRole(this.$route.params.role_id)
      ])
    } catch (e) {
      if (e instanceof RecordNotFound) {
        await this.$router.push({name: 'contract_manager.list'})
      }
    }
    this.loading = false
  },
  computed: {
    ...mapGetters('contractManager', [
      'contract_manager',
      'role',
    ]),
  },
  methods: {
    ...mapActions('contractManager', [
      'fetchContractManager',
      'fetchRole',
      'updateRole',
    ]),
    ...mapActions('login', [
      'fetchConfig'
    ]),
    async onSave(data) {
      await this.updateRole(data)
      await this.$router.push({
        name: 'contract_manager.roles', 
        params: {id: this.contract_manager.id}
      })
      throw new SuccessNotification(this.$pgettext('contract_manager', 'Role updated!'))
    },
    onClickSave() {
      this.$refs.role_form.triggerSave()
    },
    onReset() {
      this.$refs.role_form.onReset()
    }
  }
}
</script>